import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#1688ff', light: '#53a8ff', dark: '#0756d8', contrastText: '#ffffff' },
    secondary: { main: '#304ffe' },
    background: { default: '#020f1d', paper: '#071a2d' },
    text: { primary: '#f7fbff', secondary: '#94abc2' },
    divider: 'rgba(255,255,255,.09)',
  },
  shape: { borderRadius: 18 },
  typography: {
    fontFamily: 'Inter, Manrope, system-ui, sans-serif',
    h1: { fontWeight: 760, letterSpacing: '-0.055em' },
    h2: { fontWeight: 740, letterSpacing: '-0.045em' },
    h4: { fontWeight: 720, letterSpacing: '-0.035em' },
    button: { fontWeight: 700, textTransform: 'none' },
  },
  components: {
    MuiButton: { styleOverrides: { root: { borderRadius: 999, minHeight: 44, paddingInline: 22 } } },
    MuiCard: { styleOverrides: { root: { backgroundImage: 'linear-gradient(145deg, rgba(11,36,61,.96), rgba(4,22,39,.96))', border: '1px solid rgba(45,139,255,.16)', boxShadow: '0 20px 60px rgba(0,8,20,.22)' } } },
    MuiDialog: { styleOverrides: { paper: { backgroundImage: 'none', border: '1px solid rgba(255,255,255,.1)' } } },
    MuiTextField: { defaultProps: { variant: 'outlined' } },
  },
});

export default theme;
